export const CITY_LOCATIONS = [
  {
    slug: "chicago-il",
    city: "Chicago",
    state: "IL",
    fullName: "Chicago, Illinois",
    metro: "Chicago Metro (Chicago & Joliet)",
    lat: 41.88,
    lng: -87.63,
    keywords: "truck driver jobs Chicago IL, CDL-A jobs Chicago Illinois, local truck driver Chicago, OTR driver jobs near Chicago, truck driving jobs Joliet IL",
    description: "Hylas Companion is hiring CDL-A truck drivers for local W2, OTR, and lease purchase positions in the Chicago, Illinois area. Routes out of Chicago and Joliet serving retail accounts including Kroger, Walmart, Dollar Tree, and more.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)", "$1 CPM Team Driving"],
    accounts: ["Kroger", "Walmart", "Dollar Tree", "Family Dollar", "Target"],
    extraCopy: "Chicago is one of our largest hiring markets. We have local W2 positions with home-daily options, plus OTR seats running out of the Chicago/Joliet hub. Dedicated freight accounts mean steady loads — no waiting.",
    nearby: ["joliet-il", "portage-in", "milwaukee-wi"],
  },
  {
    slug: "denver-co",
    city: "Denver",
    state: "CO",
    fullName: "Denver, Colorado",
    metro: "Denver Metro",
    lat: 39.74,
    lng: -104.99,
    keywords: "truck driver jobs Denver CO, CDL-A jobs Denver Colorado, OTR driver Denver, truck driving jobs Colorado",
    description: "Hylas Companion is hiring CDL-A truck drivers in Denver, Colorado. Local W2, OTR company driver, and lease purchase positions available. New trucks, top pay, and flexible home time.",
    positions: ["OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)", "Local W2 ($1,200–$2,500/wk)", "$1 CPM Team Driving"],
    accounts: ["Kroger", "Walmart", "Target"],
    extraCopy: "Denver is a major freight hub connecting the Mountain West. We hire OTR company drivers, lease drivers, and local W2 drivers based in the Denver metro. Great gateway to western lanes.",
    nearby: ["phoenix-az", "oklahoma-city-ok"],
  },
  {
    slug: "baltimore-md",
    city: "Baltimore",
    state: "MD",
    fullName: "Baltimore, Maryland",
    metro: "Baltimore Metro",
    lat: 39.28,
    lng: -76.61,
    keywords: "truck driver jobs Baltimore MD, CDL-A jobs Baltimore Maryland, local truck driver Baltimore, OTR driver jobs Maryland",
    description: "Hylas Companion is hiring CDL-A truck drivers in Baltimore, Maryland. Local W2, flatbed, reefer, and OTR positions available. All 48 states coverage, no hiring restriction.",
    positions: ["OTR Company Driver (85–90¢ CPM)", "Flatbed Driver (90¢ CPM)", "Lease Purchase (88%)", "Local W2"],
    accounts: ["Walmart", "Target", "Dollar Tree"],
    extraCopy: "Baltimore is strategically located on the East Coast for I-95 corridor freight. We hire flatbed, reefer, and dry van drivers out of the Baltimore area with steady freight to the Northeast and Southeast.",
    nearby: ["harrisburg-pa", "west-jefferson-oh", "charlotte-nc"],
  },
  {
    slug: "joliet-il",
    city: "Joliet",
    state: "IL",
    fullName: "Joliet, Illinois",
    metro: "Joliet / Chicago Southland",
    lat: 41.52,
    lng: -88.08,
    keywords: "truck driver jobs Joliet IL, CDL-A jobs Joliet Illinois, local truck driver Joliet, truck driving jobs near Chicago southland",
    description: "Hylas Companion is hiring CDL-A truck drivers in Joliet, Illinois. Local W2 home-daily and weekly positions, plus OTR company driver and lease purchase seats. Part of the greater Chicago logistics hub.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85¢+ CPM)", "Lease Purchase (88%)", "Trainee Program"],
    accounts: ["Kroger", "Walmart", "Dollar Tree", "Family Dollar"],
    extraCopy: "Joliet is a top freight market and part of our Chicago-area operations. Local W2 drivers based in Joliet can expect home-daily or home-weekly schedules with dedicated retail freight.",
    nearby: ["chicago-il", "portage-in", "indianapolis-in"],
  },
  {
    slug: "oklahoma-city-ok",
    city: "Oklahoma City",
    state: "OK",
    fullName: "Oklahoma City, Oklahoma",
    metro: "Oklahoma City / Sand Springs",
    lat: 35.47,
    lng: -97.52,
    keywords: "truck driver jobs Oklahoma City OK, CDL-A jobs Oklahoma, OTR driver Oklahoma, truck driving jobs Sand Springs OK",
    description: "Hylas Companion is hiring CDL-A truck drivers in Oklahoma City, Oklahoma and the Sand Springs area. OTR company driver, lease purchase, and local W2 positions available.",
    positions: ["OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)", "Local W2", "$1 CPM Team Driving"],
    accounts: ["Walmart", "Dollar Tree", "Target"],
    extraCopy: "Oklahoma is a crossroads for major freight lanes connecting the Midwest, Southwest, and South. We have OTR seats and local W2 options for drivers based in the Oklahoma City and Sand Springs area.",
    nearby: ["denver-co", "phoenix-az", "kansas-city-mo", "dallas-tx"],
  },
  {
    slug: "phoenix-az",
    city: "Phoenix",
    state: "AZ",
    fullName: "Phoenix, Arizona",
    metro: "Phoenix / Mesa / Casa Grande",
    lat: 33.45,
    lng: -112.07,
    keywords: "truck driver jobs Phoenix AZ, CDL-A jobs Phoenix Arizona, local truck driver Phoenix, OTR driver jobs Arizona, Mesa AZ truck driver jobs",
    description: "Hylas Companion is hiring CDL-A truck drivers in Phoenix, Arizona and the greater Valley area including Mesa and Casa Grande. Dry van, flatbed, and reefer positions available.",
    positions: ["OTR Company Driver (85–90¢ CPM)", "Flatbed Driver (90¢ CPM)", "Lease Purchase (88%)", "Local W2"],
    accounts: ["Walmart", "Target", "Dollar Tree"],
    extraCopy: "Phoenix is a growing Southwest freight hub with strong year-round lanes. We hire OTR and local drivers across the Phoenix metro, including Mesa and Casa Grande — all with new trucks and weekly pay.",
    nearby: ["denver-co", "oklahoma-city-ok"],
  },
  {
    slug: "west-jefferson-oh",
    city: "West Jefferson",
    state: "OH",
    fullName: "West Jefferson, Ohio",
    metro: "West Jefferson / Columbus Metro",
    lat: 39.94,
    lng: -83.27,
    keywords: "truck driver jobs West Jefferson OH, CDL-A jobs Ohio, truck driver jobs Columbus Ohio area, OTR driver Ohio",
    description: "Hylas Companion is hiring CDL-A truck drivers in West Jefferson, Ohio (Columbus metro area). Local W2, OTR company driver, and lease purchase positions available. All 48 states coverage.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85¢+ CPM)", "Lease Purchase (88%)", "JB Hunt Account Positions"],
    accounts: ["Walmart", "Kroger", "Target", "Dollar Tree"],
    extraCopy: "West Jefferson is part of the Columbus, Ohio logistics corridor — one of the busiest freight markets in the Midwest. We have dedicated local W2 positions and OTR lanes running out of the West Jefferson area.",
    nearby: ["columbus-oh", "harrisburg-pa", "indianapolis-in"],
  },
  {
    slug: "harrisburg-pa",
    city: "Harrisburg",
    state: "PA",
    fullName: "Harrisburg, Pennsylvania",
    metro: "Harrisburg / Chambersburg / York",
    lat: 40.27,
    lng: -76.89,
    keywords: "truck driver jobs Harrisburg PA, CDL-A jobs Harrisburg Pennsylvania, local truck driver Harrisburg, OTR driver Pennsylvania, JB Hunt jobs Harrisburg PA",
    description: "Hylas Companion is hiring CDL-A truck drivers in Harrisburg, Pennsylvania and the surrounding South-Central PA market. JB Hunt, Hub Group, and Swift Local positions available with local W2 and OTR options.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)", "JB Hunt & Hub Group Accounts"],
    accounts: ["Walmart", "Target", "Dollar Tree", "Kroger"],
    extraCopy: "Harrisburg is one of the highest-density local driver markets in our network with positions from multiple carrier accounts. South-Central Pennsylvania is a logistics crossroads for the Northeast corridor — steady freight, no slow seasons.",
    nearby: ["west-jefferson-oh", "baltimore-md", "columbus-oh", "charlotte-nc"],
  },
  {
    slug: "indianapolis-in",
    city: "Indianapolis",
    state: "IN",
    fullName: "Indianapolis, Indiana",
    metro: "Indianapolis Metro",
    lat: 39.77,
    lng: -86.16,
    keywords: "truck driver jobs Indianapolis IN, CDL-A jobs Indianapolis Indiana, local truck driver Indianapolis, JB Hunt jobs Indiana, Hub Group driver Indianapolis",
    description: "Hylas Companion is hiring CDL-A truck drivers in Indianapolis, Indiana. Local W2 home-daily and home-weekly positions available through JB Hunt and Hub Group accounts, plus OTR company driver seats.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)", "JB Hunt & Hub Group Accounts"],
    accounts: ["Walmart", "Kroger", "Dollar Tree", "Target"],
    extraCopy: "Indianapolis is the freight hub of the Midwest — perfectly located for I-65, I-70, and I-74 corridors. We have local W2 positions from major carrier accounts with home-daily schedules available.",
    nearby: ["joliet-il", "portage-in", "columbus-oh", "louisville-ky"],
  },
  {
    slug: "columbus-oh",
    city: "Columbus",
    state: "OH",
    fullName: "Columbus, Ohio",
    metro: "Columbus Metro",
    lat: 39.96,
    lng: -82.99,
    keywords: "truck driver jobs Columbus OH, CDL-A jobs Columbus Ohio, local truck driver Columbus, JB Hunt jobs Columbus Ohio, Hub Group driver Ohio",
    description: "Hylas Companion is hiring CDL-A truck drivers in Columbus, Ohio. Local W2, JB Hunt, Hub Group, and OTR company driver positions available. Home-daily and home-weekly schedules with weekly pay.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)", "JB Hunt & Hub Group Accounts"],
    accounts: ["Walmart", "Kroger", "Target", "Dollar Tree", "Family Dollar"],
    extraCopy: "Columbus is Ohio's largest freight market. Our JB Hunt and Hub Group dedicated accounts here offer some of the most consistent local freight in the region — home-daily available for qualified drivers.",
    nearby: ["west-jefferson-oh", "indianapolis-in", "harrisburg-pa"],
  },
  // ─── New: Hub Group sub-markets ─────────────────────────────
  {
    slug: "portage-in",
    city: "Portage",
    state: "IN",
    fullName: "Portage, Indiana",
    metro: "Portage / NW Indiana (Chicago Metro)",
    lat: 41.57,
    lng: -87.17,
    keywords: "truck driver jobs Portage IN, CDL-A jobs Portage Indiana, local truck driver northwest Indiana, Hub Group driver Portage, truck driving jobs near Chicago Indiana",
    description: "Hylas Companion is hiring CDL-A truck drivers in Portage, Indiana — part of the Chicago-area logistics corridor. Hub Group local W2 positions available with home-daily and weekly schedules.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "Hub Group Account", "OTR Company Driver (85¢+ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Target", "Dollar Tree"],
    extraCopy: "Portage is in northwest Indiana, minutes from the Illinois border and the greater Chicago freight market. Hub Group positions here offer home-daily local routes with steady dedicated freight — no over-the-road required.",
    nearby: ["chicago-il", "joliet-il", "racine-wi"],
  },
  {
    slug: "racine-wi",
    city: "Racine",
    state: "WI",
    fullName: "Racine, Wisconsin",
    metro: "Racine / Kenosha / Milwaukee Corridor",
    lat: 42.73,
    lng: -87.78,
    keywords: "truck driver jobs Racine WI, CDL-A jobs Racine Wisconsin, local truck driver Racine, JB Hunt driver Wisconsin, truck driving jobs Kenosha WI",
    description: "Hylas Companion is hiring CDL-A truck drivers in Racine, Wisconsin. JB Hunt local W2 positions available with home-daily schedules. Part of the Chicago-Milwaukee I-94 corridor with consistent retail freight.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "JB Hunt Account", "OTR Company Driver (85¢+ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Target", "Kroger"],
    extraCopy: "Racine sits on the Lake Michigan corridor between Chicago and Milwaukee — one of the most freight-dense lanes in the Midwest. JB Hunt local positions here have strong dedicated freight with home-daily options.",
    nearby: ["milwaukee-wi", "chicago-il", "portage-in"],
  },
  {
    slug: "oconomowoc-wi",
    city: "Oconomowoc",
    state: "WI",
    fullName: "Oconomowoc, Wisconsin",
    metro: "Oconomowoc / Greater Milwaukee",
    lat: 43.10,
    lng: -88.50,
    keywords: "truck driver jobs Oconomowoc WI, CDL-A jobs Wisconsin, local truck driver Oconomowoc, JB Hunt driver near Milwaukee, truck driving jobs Waukesha County WI",
    description: "Hylas Companion is hiring CDL-A truck drivers in Oconomowoc, Wisconsin. JB Hunt local W2 positions available near Milwaukee with home-daily schedules and weekly pay.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "JB Hunt Account", "OTR Company Driver (85¢+ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Dollar Tree", "Target"],
    extraCopy: "Oconomowoc is located in Waukesha County, part of greater Milwaukee's freight network. JB Hunt local positions here offer home-daily schedules with consistent retail freight in one of Wisconsin's fastest-growing logistics markets.",
    nearby: ["milwaukee-wi", "racine-wi", "portage-in"],
  },
  {
    slug: "milwaukee-wi",
    city: "Milwaukee",
    state: "WI",
    fullName: "Milwaukee, Wisconsin",
    metro: "Milwaukee Metro",
    lat: 43.04,
    lng: -87.91,
    keywords: "truck driver jobs Milwaukee WI, CDL-A jobs Milwaukee Wisconsin, local truck driver Milwaukee, Hub Group driver Milwaukee, JB Hunt driver Wisconsin, OTR driver Milwaukee",
    description: "Hylas Companion is hiring CDL-A truck drivers in Milwaukee, Wisconsin. Hub Group and JB Hunt local W2 positions available with home-daily schedules, plus OTR and lease purchase seats. Wisconsin's largest freight market.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "Hub Group Account", "JB Hunt Account", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Kroger", "Target", "Dollar Tree"],
    extraCopy: "Milwaukee is Wisconsin's largest city and a top Midwest logistics hub. We have Hub Group and JB Hunt dedicated local positions in the Milwaukee metro — home-daily routes, weekly pay, and some of the strongest retail freight volume in the state.",
    nearby: ["racine-wi", "oconomowoc-wi", "portage-in"],
  },
  // ─── Southeast / Mid-South Expansion ────────────────────────
  {
    slug: "memphis-tn",
    city: "Memphis",
    state: "TN",
    fullName: "Memphis, Tennessee",
    metro: "Memphis Metro / Mid-South",
    lat: 35.15,
    lng: -90.05,
    keywords: "truck driver jobs Memphis TN, CDL-A jobs Memphis Tennessee, local truck driver Memphis, JB Hunt driver Tennessee, Hub Group Memphis, OTR driver Memphis",
    description: "Hylas Companion is hiring CDL-A truck drivers in Memphis, Tennessee. JB Hunt and Hub Group local W2 and OTR positions available. Memphis is the Mid-South's largest freight hub with direct access to I-40 and I-55 corridors.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "JB Hunt Account", "Hub Group Account", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["FedEx Distribution", "Walmart", "Dollar Tree", "Target", "Kroger"],
    extraCopy: "Memphis is one of the most freight-dense cities in America — home to FedEx's global hub and a crossroads for Mid-South retail distribution. We have JB Hunt and Hub Group dedicated local positions here with home-daily options and strong weekly freight volume year-round.",
    nearby: ["nashville-tn", "louisville-ky", "kansas-city-mo", "houston-tx"],
  },
  {
    slug: "nashville-tn",
    city: "Nashville",
    state: "TN",
    fullName: "Nashville, Tennessee",
    metro: "Nashville Metro / Middle Tennessee",
    lat: 36.17,
    lng: -86.78,
    keywords: "truck driver jobs Nashville TN, CDL-A jobs Nashville Tennessee, local truck driver Nashville, Hub Group Nashville, JB Hunt driver Tennessee, OTR driver Nashville",
    description: "Hylas Companion is hiring CDL-A truck drivers in Nashville, Tennessee. Hub Group and JB Hunt local W2 and OTR positions available. Nashville is a booming Southeast freight market with major distribution demand.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "Hub Group Account", "JB Hunt Account", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Kroger", "Target", "Dollar Tree", "Amazon Distribution"],
    extraCopy: "Nashville is one of the fastest-growing freight markets in the Southeast. Hub Group and JB Hunt both have major operations in the Nashville area, with local W2 home-daily routes and consistent retail freight. Located at the crossroads of I-24, I-40, and I-65 — ideal for Southeast regional and OTR lanes.",
    nearby: ["memphis-tn", "louisville-ky", "atlanta-ga"],
  },
  {
    slug: "atlanta-ga",
    city: "Atlanta",
    state: "GA",
    fullName: "Atlanta, Georgia",
    metro: "Atlanta Metro",
    lat: 33.75,
    lng: -84.39,
    keywords: "truck driver jobs Atlanta GA, CDL-A jobs Atlanta Georgia, local truck driver Atlanta, JB Hunt driver Georgia, Hub Group Atlanta, OTR driver Atlanta",
    description: "Hylas Companion is hiring CDL-A truck drivers in Atlanta, Georgia. JB Hunt and Hub Group local W2 and OTR positions. Atlanta is the Southeast's largest logistics hub with access to port freight, retail distribution, and I-285/I-75/I-85 corridors.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "JB Hunt Account", "Hub Group Account", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Kroger", "Target", "Dollar Tree", "Home Depot"],
    extraCopy: "Atlanta is the freight capital of the Southeast. Our JB Hunt and Hub Group accounts in Atlanta move retail and distribution freight across Georgia and the Southeast. Local W2 home-daily positions available, plus OTR seats connecting Atlanta to the Port of Savannah and Midwest lanes.",
    nearby: ["nashville-tn", "charlotte-nc", "memphis-tn"],
  },
  {
    slug: "charlotte-nc",
    city: "Charlotte",
    state: "NC",
    fullName: "Charlotte, North Carolina",
    metro: "Charlotte Metro / Carolinas",
    lat: 35.23,
    lng: -80.84,
    keywords: "truck driver jobs Charlotte NC, CDL-A jobs Charlotte North Carolina, local truck driver Charlotte, JB Hunt driver North Carolina, Hub Group Charlotte, OTR driver Carolinas",
    description: "Hylas Companion is hiring CDL-A truck drivers in Charlotte, North Carolina. JB Hunt and Hub Group local W2 and OTR positions available. Charlotte is the Carolinas' largest freight market with strong East Coast corridor connections.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "JB Hunt Account", "Hub Group Account", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Target", "Dollar Tree", "Lowe's", "Kroger"],
    extraCopy: "Charlotte is a growing Southeast logistics hub positioned between Atlanta and the Northeast I-95 corridor. We have JB Hunt and Hub Group dedicated local positions in the Charlotte metro, plus OTR lanes running north to Baltimore and south to Atlanta. Strong freight demand with home-daily options available.",
    nearby: ["atlanta-ga", "baltimore-md", "harrisburg-pa"],
  },
  {
    slug: "louisville-ky",
    city: "Louisville",
    state: "KY",
    fullName: "Louisville, Kentucky",
    metro: "Louisville Metro",
    lat: 38.25,
    lng: -85.76,
    keywords: "truck driver jobs Louisville KY, CDL-A jobs Louisville Kentucky, local truck driver Louisville, Hub Group Louisville, JB Hunt driver Kentucky, UPS freight Louisville",
    description: "Hylas Companion is hiring CDL-A truck drivers in Louisville, Kentucky. Hub Group and JB Hunt local W2 and OTR positions available. Louisville is a top freight market at the intersection of I-64, I-65, and I-71.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "Hub Group Account", "JB Hunt Account", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Target", "Kroger", "Dollar Tree", "UPS Distribution"],
    extraCopy: "Louisville sits at the intersection of three major interstates and is home to one of the largest package handling facilities in the world. Hub Group and JB Hunt both have strong dedicated freight accounts in the Louisville area — local W2 home-daily positions available with some of the most consistent freight volumes in the Midwest-South corridor.",
    nearby: ["nashville-tn", "indianapolis-in", "kansas-city-mo"],
  },
  {
    slug: "kansas-city-mo",
    city: "Kansas City",
    state: "MO",
    fullName: "Kansas City, Missouri",
    metro: "Kansas City Metro (MO/KS)",
    lat: 39.10,
    lng: -94.58,
    keywords: "truck driver jobs Kansas City MO, CDL-A jobs Kansas City Missouri, local truck driver Kansas City, Hub Group Kansas City, JB Hunt driver Missouri, OTR driver Kansas City",
    description: "Hylas Companion is hiring CDL-A truck drivers in Kansas City, Missouri. Hub Group and JB Hunt local W2 and OTR positions available. Kansas City is the bridge between Midwest and South freight corridors.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "Hub Group Account", "JB Hunt Account", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Target", "Dollar Tree", "Kroger", "Cerner Freight"],
    extraCopy: "Kansas City is where the Midwest meets the South — a central freight hub at the crossing of I-70 and I-35. Hub Group has a major presence here with dedicated local freight accounts. Strong backhaul availability makes KC one of the best markets for lease and OTR drivers looking for consistent loaded miles in both directions.",
    nearby: ["oklahoma-city-ok", "louisville-ky", "memphis-tn"],
  },
  // ─── Texas Expansion ─────────────────────────────────────────
  {
    slug: "houston-tx",
    city: "Houston",
    state: "TX",
    fullName: "Houston, Texas",
    metro: "Houston Metro / Gulf Coast",
    lat: 29.76,
    lng: -95.37,
    keywords: "truck driver jobs Houston TX, CDL-A jobs Houston Texas, local truck driver Houston, JB Hunt driver Texas, Hub Group Houston, OTR driver Houston, flatbed driver Houston TX",
    description: "Hylas Companion is hiring CDL-A truck drivers in Houston, Texas. JB Hunt and Hub Group local W2 and OTR positions available. Houston is the Gulf Coast's largest freight market with direct access to port freight, petrochemical lanes, and I-10/I-45/I-69 corridors.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "JB Hunt Account", "Hub Group Account", "OTR Company Driver (85–90¢ CPM)", "Flatbed Driver (90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Target", "Dollar Tree", "Home Depot", "Kroger"],
    extraCopy: "Houston is the freight capital of the Gulf Coast — home to the Port of Houston (one of the largest in the US) and a hub for petrochemical, industrial, and retail distribution freight. JB Hunt and Hub Group both run dedicated accounts in the Houston area. We have local W2 home-daily positions plus OTR lanes connecting Houston to Dallas, Memphis, and the Southeast. No state income tax in Texas means more of every dollar stays in your pocket.",
    nearby: ["dallas-tx", "oklahoma-city-ok", "memphis-tn"],
  },
  {
    slug: "dallas-tx",
    city: "Dallas",
    state: "TX",
    fullName: "Dallas, Texas",
    metro: "Dallas–Fort Worth Metroplex",
    lat: 32.78,
    lng: -96.80,
    keywords: "truck driver jobs Dallas TX, CDL-A jobs Dallas Texas, local truck driver Dallas, JB Hunt driver Texas, Hub Group Dallas, OTR driver Dallas Fort Worth, truck driving jobs DFW",
    description: "Hylas Companion is hiring CDL-A truck drivers in the Dallas–Fort Worth Metroplex. JB Hunt and Hub Group local W2 and OTR positions available. DFW is one of the highest-volume freight markets in the United States.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "JB Hunt Account", "Hub Group Account", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)", "$1 CPM Team Driving"],
    accounts: ["Walmart", "Target", "Kroger", "Dollar Tree", "Amazon Distribution"],
    extraCopy: "Dallas–Fort Worth is the #2 inland freight market in America. JB Hunt has major operations throughout the DFW Metroplex with strong dedicated freight accounts running retail and distribution loads. Hub Group local positions here offer home-daily schedules with some of the most consistent freight volumes in the South. Texas has no state income tax, diesel is among the cheapest in the nation, and the backhaul market out of DFW is excellent in both directions.",
    nearby: ["houston-tx", "oklahoma-city-ok", "kansas-city-mo"],
  },

  // ─── Florida ─────────────────────────────────────────────────
  {
    slug: "jacksonville-fl",
    city: "Jacksonville",
    state: "FL",
    fullName: "Jacksonville, Florida",
    metro: "Jacksonville Metro / North Florida",
    lat: 30.33,
    lng: -81.66,
    keywords: "truck driver jobs Jacksonville FL, CDL-A jobs Jacksonville Florida, local truck driver Jacksonville, OTR driver North Florida, truck driving jobs Florida",
    description: "Hylas Companion is hiring CDL-A truck drivers in Jacksonville, Florida. Local W2, OTR, and lease purchase positions available. Jacksonville is Florida's top freight gateway with access to I-10, I-95, and the Port of Jacksonville.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)", "$1 CPM Team Driving"],
    accounts: ["Walmart", "Dollar Tree", "Target", "Publix", "Amazon"],
    extraCopy: "Jacksonville is the freight capital of Florida — its port and interstate access make it a natural hub for Southeast and national distribution. We have home-daily local W2 positions plus OTR lanes connecting Jacksonville to Atlanta, Charlotte, and the Northeast. Consistent freight with no state income tax in Florida.",
    nearby: ["atlanta-ga", "charlotte-nc", "orlando-fl"],
  },
  {
    slug: "orlando-fl",
    city: "Orlando",
    state: "FL",
    fullName: "Orlando, Florida",
    metro: "Orlando Metro / Central Florida",
    lat: 28.54,
    lng: -81.38,
    keywords: "truck driver jobs Orlando FL, CDL-A jobs Orlando Florida, local truck driver Orlando, OTR driver Central Florida, truck driving jobs Tampa FL",
    description: "Hylas Companion is hiring CDL-A truck drivers in Orlando, Florida. Local W2 and OTR positions available. Central Florida is a major distribution hub serving retail, hospitality, and consumer goods freight.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Publix", "Dollar Tree", "Target", "Sysco"],
    extraCopy: "Orlando and the Central Florida corridor offer high-volume retail distribution freight with home-daily options. No state income tax in Florida. Strong demand for both local and regional drivers servicing retail accounts.",
    nearby: ["jacksonville-fl", "charlotte-nc", "atlanta-ga"],
  },

  // ─── Michigan ─────────────────────────────────────────────────
  {
    slug: "detroit-mi",
    city: "Detroit",
    state: "MI",
    fullName: "Detroit, Michigan",
    metro: "Detroit Metro / Southeast Michigan",
    lat: 42.33,
    lng: -83.05,
    keywords: "truck driver jobs Detroit MI, CDL-A jobs Detroit Michigan, local truck driver Detroit, OTR driver Michigan, truck driving jobs Michigan",
    description: "Hylas Companion is hiring CDL-A truck drivers in Detroit, Michigan. Local W2, OTR company driver, and lease purchase positions available. Detroit is a major logistics hub at the US–Canada border with I-75, I-94, and I-96 corridors.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)", "Flatbed Driver (90¢ CPM)"],
    accounts: ["Walmart", "Target", "Dollar Tree", "Amazon", "Ford Distribution"],
    extraCopy: "Detroit is the automotive capital of America and one of the Midwest's busiest freight markets. Cross-border freight to Windsor, Ontario plus strong retail distribution accounts make Detroit a high-demand market. Local W2 home-daily positions available with dedicated freight running Michigan statewide.",
    nearby: ["columbus-oh", "indianapolis-in", "chicago-il"],
  },

  // ─── Minnesota ─────────────────────────────────────────────────
  {
    slug: "minneapolis-mn",
    city: "Minneapolis",
    state: "MN",
    fullName: "Minneapolis, Minnesota",
    metro: "Minneapolis–Saint Paul Metro",
    lat: 44.98,
    lng: -93.27,
    keywords: "truck driver jobs Minneapolis MN, CDL-A jobs Minneapolis Minnesota, local truck driver Minneapolis, OTR driver Minnesota, truck driving jobs Twin Cities",
    description: "Hylas Companion is hiring CDL-A truck drivers in Minneapolis–Saint Paul, Minnesota. Local W2, OTR, and lease purchase positions available. The Twin Cities is the upper Midwest's largest freight market.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)", "$1 CPM Team Driving"],
    accounts: ["Walmart", "Target", "Kroger", "Dollar Tree", "Amazon"],
    extraCopy: "Minneapolis–Saint Paul is a critical upper Midwest freight hub on I-35W and I-94. Target's global headquarters drives significant distribution freight in the metro. We have local W2 home-daily positions plus OTR lanes connecting Minneapolis to Chicago, Kansas City, and Fargo.",
    nearby: ["chicago-il", "kansas-city-mo", "fargo-nd"],
  },

  // ─── Virginia ─────────────────────────────────────────────────
  {
    slug: "richmond-va",
    city: "Richmond",
    state: "VA",
    fullName: "Richmond, Virginia",
    metro: "Richmond Metro / Central Virginia",
    lat: 37.54,
    lng: -77.44,
    keywords: "truck driver jobs Richmond VA, CDL-A jobs Richmond Virginia, local truck driver Virginia, OTR driver Virginia, truck driving jobs Northern Virginia",
    description: "Hylas Companion is hiring CDL-A truck drivers in Richmond, Virginia. Local W2, OTR, and lease purchase positions available. Richmond is positioned on I-95 between Baltimore and Charlotte for strong East Coast corridor freight.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)", "Flatbed Driver (90¢ CPM)"],
    accounts: ["Walmart", "Target", "Dollar Tree", "Kroger", "Amazon"],
    extraCopy: "Richmond sits at a critical I-95 junction midway between Baltimore and Charlotte, making it one of the East Coast's most strategic freight positions. We have local W2 drivers running Virginia statewide plus OTR lanes covering the full I-95 corridor.",
    nearby: ["baltimore-md", "charlotte-nc", "harrisburg-pa"],
  },

  // ─── Washington ─────────────────────────────────────────────────
  {
    slug: "seattle-wa",
    city: "Seattle",
    state: "WA",
    fullName: "Seattle, Washington",
    metro: "Seattle Metro / Puget Sound",
    lat: 47.60,
    lng: -122.33,
    keywords: "truck driver jobs Seattle WA, CDL-A jobs Seattle Washington, local truck driver Seattle, OTR driver Washington state, truck driving jobs Tacoma WA",
    description: "Hylas Companion is hiring CDL-A truck drivers in Seattle, Washington. Local W2, OTR, and lease purchase positions available. Seattle is the Pacific Northwest's top freight market with port access and I-5/I-90 corridors.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)", "Flatbed Driver (90¢ CPM)"],
    accounts: ["Walmart", "Target", "Costco", "Amazon", "SYSCO"],
    extraCopy: "Seattle and the greater Puget Sound area is the Pacific Northwest's freight gateway. Port of Seattle and Port of Tacoma generate massive import/export freight. Amazon's headquarters drives significant distribution freight. We have local W2 home-daily positions plus OTR lanes running the I-5 corridor to Portland and Southern California.",
    nearby: ["portland-or", "phoenix-az", "denver-co"],
  },

  // ─── New Jersey ─────────────────────────────────────────────────
  {
    slug: "newark-nj",
    city: "Newark",
    state: "NJ",
    fullName: "Newark, New Jersey",
    metro: "Newark / NY Metro Area",
    lat: 40.73,
    lng: -74.17,
    keywords: "truck driver jobs Newark NJ, CDL-A jobs New Jersey, local truck driver New Jersey, OTR driver NJ, truck driving jobs Northern NJ, NYC area truck driver",
    description: "Hylas Companion is hiring CDL-A truck drivers in Newark, New Jersey and the greater NY Metro area. Local W2, OTR, and lease purchase positions available. The Newark/NJ corridor is the densest freight market on the East Coast.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)", "$1 CPM Team Driving"],
    accounts: ["Walmart", "Target", "Amazon", "Stop & Shop", "Dollar Tree"],
    extraCopy: "The New Jersey/Newark corridor handles more freight tonnage per square mile than anywhere else in America. Port Newark-Elizabeth Marine Terminal is the busiest port on the East Coast. We have local W2 home-daily positions plus OTR lanes running the I-95 and I-78 corridors.",
    nearby: ["harrisburg-pa", "baltimore-md", "richmond-va"],
  },

  // ─── Nevada ─────────────────────────────────────────────────
  {
    slug: "las-vegas-nv",
    city: "Las Vegas",
    state: "NV",
    fullName: "Las Vegas, Nevada",
    metro: "Las Vegas Metro / Henderson",
    lat: 36.17,
    lng: -115.14,
    keywords: "truck driver jobs Las Vegas NV, CDL-A jobs Las Vegas Nevada, local truck driver Las Vegas, OTR driver Nevada, truck driving jobs Henderson NV",
    description: "Hylas Companion is hiring CDL-A truck drivers in Las Vegas, Nevada. Local W2, OTR, and lease purchase positions available. Las Vegas is a growing Southwest logistics hub on I-15 with high retail distribution demand.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)", "Flatbed Driver (90¢ CPM)"],
    accounts: ["Walmart", "Target", "Dollar Tree", "Costco", "Amazon"],
    extraCopy: "Las Vegas is a major Southwest freight hub with massive retail distribution demand driven by the hospitality industry and a rapidly growing resident population. No state income tax in Nevada. We have local W2 positions plus OTR lanes on I-15 connecting Las Vegas to Southern California, Salt Lake City, and Phoenix.",
    nearby: ["phoenix-az", "denver-co", "seattle-wa"],
  },

  // ─── Oregon ─────────────────────────────────────────────────
  {
    slug: "portland-or",
    city: "Portland",
    state: "OR",
    fullName: "Portland, Oregon",
    metro: "Portland Metro / Columbia River",
    lat: 45.52,
    lng: -122.68,
    keywords: "truck driver jobs Portland OR, CDL-A jobs Portland Oregon, local truck driver Portland, OTR driver Oregon, truck driving jobs Salem OR",
    description: "Hylas Companion is hiring CDL-A truck drivers in Portland, Oregon. Local W2, OTR, and flatbed positions available. Portland sits at the I-5/I-84 junction — the Pacific Northwest's primary inland freight crossroads.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Flatbed Driver (90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Target", "Costco", "Amazon", "SYSCO"],
    extraCopy: "Portland is a critical Pacific Northwest freight hub at the confluence of the I-5 (North-South) and I-84 (East-West) corridors. The Columbia River port handles significant bulk and container freight. We have local W2 positions plus OTR lanes running Pacific Coast and inland routes.",
    nearby: ["seattle-wa", "denver-co", "las-vegas-nv"],
  },

  // ─── Utah ─────────────────────────────────────────────────
  {
    slug: "salt-lake-city-ut",
    city: "Salt Lake City",
    state: "UT",
    fullName: "Salt Lake City, Utah",
    metro: "Salt Lake City Metro / Wasatch Front",
    lat: 40.76,
    lng: -111.89,
    keywords: "truck driver jobs Salt Lake City UT, CDL-A jobs Utah, local truck driver Salt Lake City, OTR driver Utah, truck driving jobs Ogden UT",
    description: "Hylas Companion is hiring CDL-A truck drivers in Salt Lake City, Utah. Local W2, OTR, and lease purchase positions available. Salt Lake City is the Mountain West's largest freight hub at the crossroads of I-15, I-80, and I-84.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)", "Flatbed Driver (90¢ CPM)"],
    accounts: ["Walmart", "Target", "Costco", "Dollar Tree", "Amazon"],
    extraCopy: "Salt Lake City commands the most important freight crossroads in the Mountain West. I-15 (Pacific Coast to Montana) and I-80 (coast to coast) intersect here, making SLC one of the most efficient freight relay points in America. We have local W2 positions plus OTR lanes in all four directions.",
    nearby: ["denver-co", "las-vegas-nv", "phoenix-az"],
  },

  // ─── Nebraska ─────────────────────────────────────────────────
  {
    slug: "omaha-ne",
    city: "Omaha",
    state: "NE",
    fullName: "Omaha, Nebraska",
    metro: "Omaha Metro / Council Bluffs",
    lat: 41.26,
    lng: -95.94,
    keywords: "truck driver jobs Omaha NE, CDL-A jobs Omaha Nebraska, local truck driver Omaha, OTR driver Nebraska, truck driving jobs Council Bluffs IA",
    description: "Hylas Companion is hiring CDL-A truck drivers in Omaha, Nebraska. Local W2, OTR, and lease purchase positions available. Omaha is a Midwest freight hub at the I-80/I-29 junction with strong agricultural and retail distribution freight.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)", "$1 CPM Team Driving"],
    accounts: ["Walmart", "Dollar Tree", "ConAgra", "Tyson Foods", "Target"],
    extraCopy: "Omaha sits on I-80 — the main East-West freight artery across America — at its junction with I-29. This makes Omaha a natural relay point for coast-to-coast OTR lanes. ConAgra and several major food distribution centers drive consistent local freight demand.",
    nearby: ["kansas-city-mo", "minneapolis-mn", "denver-co"],
  },

  // ─── Iowa ─────────────────────────────────────────────────
  {
    slug: "des-moines-ia",
    city: "Des Moines",
    state: "IA",
    fullName: "Des Moines, Iowa",
    metro: "Des Moines Metro",
    lat: 41.59,
    lng: -93.62,
    keywords: "truck driver jobs Des Moines IA, CDL-A jobs Des Moines Iowa, local truck driver Iowa, OTR driver Iowa, truck driving jobs Ames IA",
    description: "Hylas Companion is hiring CDL-A truck drivers in Des Moines, Iowa. Local W2, OTR, and lease purchase positions available. Des Moines is centrally positioned on I-80 and I-35 for Midwest freight.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Target", "Dollar Tree", "Hy-Vee", "Tyson Foods"],
    extraCopy: "Des Moines is the agricultural and logistics center of Iowa at the crossroads of I-80 (East-West) and I-35 (North-South). Strong food and retail distribution freight year-round. Local W2 positions available with consistent Midwest lanes.",
    nearby: ["kansas-city-mo", "minneapolis-mn", "omaha-ne"],
  },

  // ─── South Carolina ─────────────────────────────────────────────────
  {
    slug: "greenville-sc",
    city: "Greenville",
    state: "SC",
    fullName: "Greenville, South Carolina",
    metro: "Greenville–Spartanburg Metro",
    lat: 34.85,
    lng: -82.39,
    keywords: "truck driver jobs Greenville SC, CDL-A jobs South Carolina, local truck driver Greenville, OTR driver South Carolina, truck driving jobs Spartanburg SC",
    description: "Hylas Companion is hiring CDL-A truck drivers in Greenville, South Carolina. Local W2, OTR, and lease purchase positions available. The Greenville–Spartanburg corridor is a booming Southeast manufacturing and distribution hub.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)", "Flatbed Driver (90¢ CPM)"],
    accounts: ["Walmart", "Target", "Dollar Tree", "BMW (Distribution)", "Michelin"],
    extraCopy: "Greenville–Spartanburg is the fastest-growing freight market in the Southeast. BMW's US manufacturing plant and Michelin's headquarters drive strong flatbed and specialized freight demand. We have local W2 positions plus OTR lanes on I-85 connecting to Atlanta and Charlotte.",
    nearby: ["atlanta-ga", "charlotte-nc", "nashville-tn"],
  },

  // ─── Louisiana ─────────────────────────────────────────────────
  {
    slug: "baton-rouge-la",
    city: "Baton Rouge",
    state: "LA",
    fullName: "Baton Rouge, Louisiana",
    metro: "Baton Rouge Metro / Gulf South",
    lat: 30.45,
    lng: -91.13,
    keywords: "truck driver jobs Baton Rouge LA, CDL-A jobs Louisiana, local truck driver Baton Rouge, OTR driver Louisiana, truck driving jobs New Orleans LA",
    description: "Hylas Companion is hiring CDL-A truck drivers in Baton Rouge, Louisiana. Local W2, OTR, and flatbed positions available. Baton Rouge is positioned on I-10 and I-12 in the Gulf South's petrochemical freight corridor.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Flatbed Driver (90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Dollar Tree", "ExxonMobil Distribution", "Dow Chemical", "Target"],
    extraCopy: "Baton Rouge sits at the heart of the Gulf South petrochemical corridor on I-10. The Port of South Louisiana (the largest in the US by tonnage) and the concentration of chemical plants drive flatbed and tanker freight demand. We have local W2 positions plus OTR lanes connecting to Houston, Dallas, and Memphis.",
    nearby: ["houston-tx", "memphis-tn", "dallas-tx"],
  },

  // ─── Mississippi ─────────────────────────────────────────────────
  {
    slug: "jackson-ms",
    city: "Jackson",
    state: "MS",
    fullName: "Jackson, Mississippi",
    metro: "Jackson Metro",
    lat: 32.30,
    lng: -90.18,
    keywords: "truck driver jobs Jackson MS, CDL-A jobs Mississippi, local truck driver Mississippi, OTR driver Mississippi, truck driving jobs Ridgeland MS",
    description: "Hylas Companion is hiring CDL-A truck drivers in Jackson, Mississippi. Local W2, OTR, and lease purchase positions available. Jackson is Mississippi's freight hub at the I-20/I-55 junction.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Dollar Tree", "Target", "Kroger", "Amazon"],
    extraCopy: "Jackson sits at the crossing of I-20 (East-West) and I-55 (North-South), making it Mississippi's primary freight relay point. Strong retail distribution freight with local W2 home-weekly options and OTR lanes to Memphis, New Orleans, and Dallas.",
    nearby: ["memphis-tn", "baton-rouge-la", "dallas-tx"],
  },

  // ─── Arkansas ─────────────────────────────────────────────────
  {
    slug: "little-rock-ar",
    city: "Little Rock",
    state: "AR",
    fullName: "Little Rock, Arkansas",
    metro: "Little Rock Metro",
    lat: 34.75,
    lng: -92.29,
    keywords: "truck driver jobs Little Rock AR, CDL-A jobs Arkansas, local truck driver Arkansas, OTR driver Arkansas, truck driving jobs Fort Smith AR",
    description: "Hylas Companion is hiring CDL-A truck drivers in Little Rock, Arkansas. Local W2, OTR, and lease purchase positions available. Little Rock is positioned on I-40 and I-30 between Memphis and Dallas.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)", "$1 CPM Team Driving"],
    accounts: ["Walmart", "Dollar Tree", "Target", "Dillard's Distribution", "Tyson Foods"],
    extraCopy: "Little Rock is Arkansas's freight hub at the junction of I-40 (coast to coast) and I-30 (connecting to Dallas). Walmart's corporate HQ in Bentonville means some of the heaviest retail freight lanes in the South pass through Arkansas. We have local W2 positions plus strong OTR lanes East–West and South.",
    nearby: ["memphis-tn", "dallas-tx", "kansas-city-mo"],
  },

  // ─── Alabama ─────────────────────────────────────────────────
  {
    slug: "birmingham-al",
    city: "Birmingham",
    state: "AL",
    fullName: "Birmingham, Alabama",
    metro: "Birmingham Metro",
    lat: 33.52,
    lng: -86.80,
    keywords: "truck driver jobs Birmingham AL, CDL-A jobs Alabama, local truck driver Birmingham, OTR driver Alabama, truck driving jobs Huntsville AL",
    description: "Hylas Companion is hiring CDL-A truck drivers in Birmingham, Alabama. Local W2, OTR, and flatbed positions available. Birmingham is positioned on I-20 and I-65 as Alabama's manufacturing and distribution hub.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Flatbed Driver (90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Dollar Tree", "Target", "Mercedes-Benz (Distribution)", "Honda"],
    extraCopy: "Birmingham is Alabama's largest freight market at the intersection of I-20 and I-65. The state's large automotive manufacturing base — Mercedes, Honda, Hyundai — drives strong flatbed and specialized freight. We have local W2 positions plus OTR lanes connecting to Atlanta, Nashville, and Memphis.",
    nearby: ["atlanta-ga", "nashville-tn", "memphis-tn"],
  },

  // ─── Kansas ─────────────────────────────────────────────────
  {
    slug: "wichita-ks",
    city: "Wichita",
    state: "KS",
    fullName: "Wichita, Kansas",
    metro: "Wichita Metro",
    lat: 37.69,
    lng: -97.34,
    keywords: "truck driver jobs Wichita KS, CDL-A jobs Kansas, local truck driver Wichita, OTR driver Kansas, truck driving jobs Topeka KS",
    description: "Hylas Companion is hiring CDL-A truck drivers in Wichita, Kansas. Local W2, OTR, and lease purchase positions available. Wichita is Kansas's largest freight market on I-35 and I-135.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Dollar Tree", "Target", "Koch Industries", "Spirit AeroSystems"],
    extraCopy: "Wichita sits at the crossroads of I-35 (Dallas to Minneapolis) and I-135, making it an important relay point for central corridor freight. Strong agricultural and aerospace manufacturing freight. Local W2 positions with dedicated runs to Kansas City and Oklahoma City.",
    nearby: ["kansas-city-mo", "oklahoma-city-ok", "denver-co"],
  },

  // ─── California ─────────────────────────────────────────────────
  {
    slug: "los-angeles-ca",
    city: "Los Angeles",
    state: "CA",
    fullName: "Los Angeles, California",
    metro: "Los Angeles Metro / Inland Empire",
    lat: 34.05,
    lng: -118.24,
    keywords: "truck driver jobs Los Angeles CA, CDL-A jobs Los Angeles California, local truck driver LA, OTR driver California, truck driving jobs Inland Empire CA, port drayage driver LA",
    description: "Hylas Companion is hiring CDL-A truck drivers in Los Angeles, California and the Inland Empire. Local W2, OTR, and port drayage positions available. LA is the largest freight market in the United States.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Port Drayage", "Lease Purchase (88%)", "Flatbed Driver (90¢ CPM)"],
    accounts: ["Walmart", "Target", "Amazon", "Costco", "Home Depot"],
    extraCopy: "The Port of Los Angeles and Port of Long Beach together handle 40% of all US imports. The Inland Empire (Riverside, San Bernardino) is the largest logistics real estate market in the world. We have local W2 positions in the LA basin plus OTR lanes running I-5, I-10, and I-40 connecting to all US markets.",
    nearby: ["las-vegas-nv", "phoenix-az", "portland-or"],
  },

  // ─── New York ─────────────────────────────────────────────────
  {
    slug: "buffalo-ny",
    city: "Buffalo",
    state: "NY",
    fullName: "Buffalo, New York",
    metro: "Buffalo–Niagara Metro",
    lat: 42.89,
    lng: -78.87,
    keywords: "truck driver jobs Buffalo NY, CDL-A jobs New York state, local truck driver Buffalo, OTR driver upstate New York, truck driving jobs Rochester NY",
    description: "Hylas Companion is hiring CDL-A truck drivers in Buffalo, New York. Local W2, OTR, and lease purchase positions available. Buffalo is the gateway to the US–Canada border on I-90 and I-190.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)", "$1 CPM Team Driving"],
    accounts: ["Walmart", "Target", "Dollar Tree", "Wegmans", "Amazon"],
    extraCopy: "Buffalo–Niagara is the busiest US–Canada border crossing in the Northeast, handling more commercial freight than any other Great Lakes crossing. I-90 (New York State Thruway) connects Buffalo to New York City and Chicago. We have local W2 positions plus OTR lanes covering the full Northeast and cross-border routes to Ontario.",
    nearby: ["harrisburg-pa", "columbus-oh", "detroit-mi"],
  },

  // ─── Massachusetts ─────────────────────────────────────────────────
  {
    slug: "boston-ma",
    city: "Boston",
    state: "MA",
    fullName: "Boston, Massachusetts",
    metro: "Boston Metro / Greater New England",
    lat: 42.36,
    lng: -71.06,
    keywords: "truck driver jobs Boston MA, CDL-A jobs Massachusetts, local truck driver Boston, OTR driver New England, truck driving jobs Worcester MA",
    description: "Hylas Companion is hiring CDL-A truck drivers in Boston, Massachusetts. Local W2, OTR, and lease purchase positions available. Boston is New England's largest freight market and a critical I-90/I-93/I-95 hub.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Stop & Shop", "Market Basket", "Amazon", "Dollar Tree"],
    extraCopy: "Boston and Greater New England generate consistent dense-freight demand year-round. The Port of Boston handles significant container freight, and New England's high population density creates strong retail and grocery distribution needs. We have local W2 positions plus OTR lanes on I-90 and I-95 connecting the Northeast corridor.",
    nearby: ["newark-nj", "harrisburg-pa", "buffalo-ny"],
  },

  // ─── Michigan ─────────────────────────────────────────────────
  {
    slug: "grand-rapids-mi",
    city: "Grand Rapids",
    state: "MI",
    fullName: "Grand Rapids, Michigan",
    metro: "Grand Rapids Metro / West Michigan",
    lat: 42.96,
    lng: -85.67,
    keywords: "truck driver jobs Grand Rapids MI, CDL-A jobs West Michigan, local truck driver Grand Rapids, OTR driver Michigan, truck driving jobs Kalamazoo MI",
    description: "Hylas Companion is hiring CDL-A truck drivers in Grand Rapids, Michigan. Local W2, OTR, and lease purchase positions available. West Michigan is a growing furniture, food processing, and retail distribution hub.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Meijer", "Dollar Tree", "Steelcase Distribution", "Amazon"],
    extraCopy: "Grand Rapids is the freight center of West Michigan and one of Michigan's fastest-growing logistics markets. Meijer's distribution network, furniture manufacturing, and food processing industries drive consistent freight demand. Local W2 home-daily positions available with OTR lanes connecting to Chicago and Detroit.",
    nearby: ["detroit-mi", "chicago-il", "indianapolis-in"],
  },

  // ─── North Dakota ─────────────────────────────────────────────────
  {
    slug: "fargo-nd",
    city: "Fargo",
    state: "ND",
    fullName: "Fargo, North Dakota",
    metro: "Fargo–Moorhead Metro",
    lat: 46.88,
    lng: -96.79,
    keywords: "truck driver jobs Fargo ND, CDL-A jobs North Dakota, local truck driver Fargo, OTR driver North Dakota, truck driving jobs Bismarck ND",
    description: "Hylas Companion is hiring CDL-A truck drivers in Fargo, North Dakota. Local W2, OTR, and lease purchase positions available. Fargo is the upper Great Plains freight hub at the I-29/I-94 crossroads.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)", "Flatbed Driver (90¢ CPM)"],
    accounts: ["Walmart", "Dollar Tree", "Target", "ADM Grain", "Case IH"],
    extraCopy: "Fargo sits at the junction of I-29 (North-South along the Red River) and I-94 (East-West), making it the critical freight relay point for the upper Great Plains. Strong agricultural and energy equipment freight. We have local W2 positions plus OTR lanes to Minneapolis, Omaha, and Billings.",
    nearby: ["minneapolis-mn", "omaha-ne", "kansas-city-mo"],
  },

  // ─── South Dakota ─────────────────────────────────────────────────
  {
    slug: "sioux-falls-sd",
    city: "Sioux Falls",
    state: "SD",
    fullName: "Sioux Falls, South Dakota",
    metro: "Sioux Falls Metro",
    lat: 43.55,
    lng: -96.73,
    keywords: "truck driver jobs Sioux Falls SD, CDL-A jobs South Dakota, local truck driver Sioux Falls, OTR driver South Dakota, truck driving jobs Rapid City SD",
    description: "Hylas Companion is hiring CDL-A truck drivers in Sioux Falls, South Dakota. Local W2, OTR, and lease purchase positions available. Sioux Falls is the freight hub of the Dakotas on I-90 and I-29.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Dollar Tree", "Sanford Health Distribution", "Tyson Foods", "Target"],
    extraCopy: "Sioux Falls is the largest city in the Dakotas and its primary freight hub, positioned at the I-90/I-29 crossing. South Dakota has no state income tax. Strong food processing and agricultural freight with OTR lanes connecting to Minneapolis and Omaha.",
    nearby: ["minneapolis-mn", "omaha-ne", "fargo-nd"],
  },

  // ─── Montana ─────────────────────────────────────────────────
  {
    slug: "billings-mt",
    city: "Billings",
    state: "MT",
    fullName: "Billings, Montana",
    metro: "Billings Metro",
    lat: 45.78,
    lng: -108.50,
    keywords: "truck driver jobs Billings MT, CDL-A jobs Montana, local truck driver Billings, OTR driver Montana, truck driving jobs Great Falls MT",
    description: "Hylas Companion is hiring CDL-A truck drivers in Billings, Montana. Local W2, OTR, and flatbed positions available. Billings is the Northern Rockies freight hub on I-90 and I-94.",
    positions: ["OTR Company Driver (85–90¢ CPM)", "Flatbed Driver (90¢ CPM)", "Local W2 ($1,200–$2,500/wk)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Dollar Tree", "ExxonMobil Refinery", "Cenex Harvest States", "Target"],
    extraCopy: "Billings is the largest city in Montana and the Northern Rockies freight gateway. ExxonMobil's large Billings refinery drives bulk and tanker freight. Flatbed positions are particularly strong here for energy equipment and agricultural loads. OTR lanes connect to Denver, Salt Lake City, and Fargo.",
    nearby: ["denver-co", "salt-lake-city-ut", "fargo-nd"],
  },

  // ─── Idaho ─────────────────────────────────────────────────
  {
    slug: "boise-id",
    city: "Boise",
    state: "ID",
    fullName: "Boise, Idaho",
    metro: "Boise Metro / Treasure Valley",
    lat: 43.62,
    lng: -116.20,
    keywords: "truck driver jobs Boise ID, CDL-A jobs Idaho, local truck driver Boise, OTR driver Idaho, truck driving jobs Nampa ID",
    description: "Hylas Companion is hiring CDL-A truck drivers in Boise, Idaho. Local W2, OTR, and flatbed positions available. Boise is the Mountain West's fastest-growing freight market on I-84.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Flatbed Driver (90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Target", "Costco", "Amazon", "Lamb Weston"],
    extraCopy: "Boise and the Treasure Valley are among the fastest-growing regions in the US, creating high demand for local delivery and distribution drivers. Lamb Weston (potato processing) drives strong reefer and flatbed freight. We have local W2 positions plus OTR lanes on I-84 connecting to Portland and Salt Lake City.",
    nearby: ["salt-lake-city-ut", "portland-or", "seattle-wa"],
  },

  // ─── Wyoming ─────────────────────────────────────────────────
  {
    slug: "cheyenne-wy",
    city: "Cheyenne",
    state: "WY",
    fullName: "Cheyenne, Wyoming",
    metro: "Cheyenne Metro",
    lat: 41.14,
    lng: -104.82,
    keywords: "truck driver jobs Cheyenne WY, CDL-A jobs Wyoming, local truck driver Wyoming, OTR driver Wyoming, truck driving jobs Casper WY",
    description: "Hylas Companion is hiring CDL-A truck drivers in Cheyenne, Wyoming. OTR, flatbed, and lease purchase positions available. Cheyenne is the I-80/I-25 junction — a critical relay point for coast-to-coast OTR lanes.",
    positions: ["OTR Company Driver (85–90¢ CPM)", "Flatbed Driver (90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Dollar Tree", "Energy Transfer", "Warren Trucking"],
    extraCopy: "Cheyenne sits at the critical crossing of I-80 (the main East-West OTR artery) and I-25 (Denver to Billings). Wyoming's low cost of living, no state income tax, and strategic position make it ideal for OTR drivers based in the Mountain West. Strong energy equipment and flatbed freight.",
    nearby: ["denver-co", "salt-lake-city-ut", "billings-mt"],
  },

  // ─── New Mexico ─────────────────────────────────────────────────
  {
    slug: "albuquerque-nm",
    city: "Albuquerque",
    state: "NM",
    fullName: "Albuquerque, New Mexico",
    metro: "Albuquerque Metro",
    lat: 35.08,
    lng: -106.65,
    keywords: "truck driver jobs Albuquerque NM, CDL-A jobs New Mexico, local truck driver Albuquerque, OTR driver New Mexico, truck driving jobs Santa Fe NM",
    description: "Hylas Companion is hiring CDL-A truck drivers in Albuquerque, New Mexico. Local W2, OTR, and flatbed positions available. Albuquerque is the Southwest freight hub on I-40 and I-25.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Flatbed Driver (90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Dollar Tree", "Target", "Sysco", "Amazon"],
    extraCopy: "Albuquerque sits at the crossing of I-40 (the Southern transcontinental route) and I-25 (the Rocky Mountain corridor), making it the critical relay point for Southwest freight. Strong construction and energy equipment flatbed lanes, plus steady retail distribution freight.",
    nearby: ["phoenix-az", "dallas-tx", "denver-co"],
  },

  // ─── West Virginia ─────────────────────────────────────────────────
  {
    slug: "charleston-wv",
    city: "Charleston",
    state: "WV",
    fullName: "Charleston, West Virginia",
    metro: "Charleston Metro / Kanawha Valley",
    lat: 38.35,
    lng: -81.63,
    keywords: "truck driver jobs Charleston WV, CDL-A jobs West Virginia, local truck driver West Virginia, OTR driver WV, truck driving jobs Huntington WV",
    description: "Hylas Companion is hiring CDL-A truck drivers in Charleston, West Virginia. Local W2, OTR, and flatbed positions available. Charleston is West Virginia's freight hub on I-64, I-77, and I-79.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Flatbed Driver (90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Dollar Tree", "Target", "Kroger", "Amazon"],
    extraCopy: "Charleston is West Virginia's freight center at the intersection of three interstates. Strong industrial and energy-related flatbed freight from the region's coal and natural gas operations. We have local W2 positions plus OTR lanes connecting to Columbus, Charlotte, and Baltimore.",
    nearby: ["columbus-oh", "charlotte-nc", "richmond-va"],
  },

  // ─── Delaware ─────────────────────────────────────────────────
  {
    slug: "wilmington-de",
    city: "Wilmington",
    state: "DE",
    fullName: "Wilmington, Delaware",
    metro: "Wilmington Metro / Delmarva",
    lat: 39.74,
    lng: -75.55,
    keywords: "truck driver jobs Wilmington DE, CDL-A jobs Delaware, local truck driver Delaware, OTR driver Delaware, truck driving jobs Dover DE",
    description: "Hylas Companion is hiring CDL-A truck drivers in Wilmington, Delaware. Local W2, OTR, and lease purchase positions available. Delaware's strategic I-95 location between Philadelphia and Baltimore creates strong East Coast freight demand.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Dollar Tree", "Target", "Amazon", "Wawa Distribution"],
    extraCopy: "Wilmington's position on I-95 between Philadelphia and Baltimore makes it a natural relay point for East Coast freight. Delaware's lack of sales tax drives significant retail freight. We have local W2 positions running the Delmarva Peninsula and I-95 corridor.",
    nearby: ["baltimore-md", "harrisburg-pa", "newark-nj"],
  },

  // ─── Connecticut ─────────────────────────────────────────────────
  {
    slug: "hartford-ct",
    city: "Hartford",
    state: "CT",
    fullName: "Hartford, Connecticut",
    metro: "Hartford Metro / Central Connecticut",
    lat: 41.76,
    lng: -72.68,
    keywords: "truck driver jobs Hartford CT, CDL-A jobs Connecticut, local truck driver Connecticut, OTR driver Connecticut, truck driving jobs Bridgeport CT",
    description: "Hylas Companion is hiring CDL-A truck drivers in Hartford, Connecticut. Local W2, OTR, and lease purchase positions available. Hartford is centrally positioned on I-91 and I-84 for New England and Northeast corridor freight.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Stop & Shop", "Dollar Tree", "Amazon", "Target"],
    extraCopy: "Hartford is the insurance and freight hub of Central Connecticut, positioned on I-91 (North-South New England spine) and I-84 (East-West to New York). Connecticut's dense population and proximity to NYC create high-demand local delivery routes. We have home-daily local W2 positions plus Northeast OTR lanes.",
    nearby: ["boston-ma", "newark-nj", "harrisburg-pa"],
  },

  // ─── Rhode Island ─────────────────────────────────────────────────
  {
    slug: "providence-ri",
    city: "Providence",
    state: "RI",
    fullName: "Providence, Rhode Island",
    metro: "Providence Metro / Greater Rhode Island",
    lat: 41.82,
    lng: -71.42,
    keywords: "truck driver jobs Providence RI, CDL-A jobs Rhode Island, local truck driver Providence, OTR driver Rhode Island, truck driving jobs Cranston RI",
    description: "Hylas Companion is hiring CDL-A truck drivers in Providence, Rhode Island. Local W2 and OTR positions available. Providence is positioned on I-95 between Boston and New York for Northeast corridor freight.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Stop & Shop", "Dollar Tree", "Amazon", "Target"],
    extraCopy: "Providence's location on I-95 between Boston and New York makes it a key Northeast relay point. Rhode Island's compact geography means local W2 drivers can cover the entire state in a single shift. We have home-daily local positions plus OTR lanes on the full I-95 New England corridor.",
    nearby: ["boston-ma", "hartford-ct", "newark-nj"],
  },

  // ─── New Hampshire ─────────────────────────────────────────────────
  {
    slug: "manchester-nh",
    city: "Manchester",
    state: "NH",
    fullName: "Manchester, New Hampshire",
    metro: "Manchester Metro / Southern New Hampshire",
    lat: 42.99,
    lng: -71.46,
    keywords: "truck driver jobs Manchester NH, CDL-A jobs New Hampshire, local truck driver New Hampshire, OTR driver NH, truck driving jobs Nashua NH",
    description: "Hylas Companion is hiring CDL-A truck drivers in Manchester, New Hampshire. Local W2 and OTR positions available. Southern New Hampshire is a growing logistics market on I-93 and I-293 between Boston and the North Country.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Dollar Tree", "Market Basket", "Amazon", "Target"],
    extraCopy: "Manchester and Southern New Hampshire benefit from no state income tax and proximity to the Boston metro market. Growing logistics infrastructure along the Route 3/I-93 corridor creates strong local freight demand. We have home-daily local W2 positions plus Northeast OTR lanes.",
    nearby: ["boston-ma", "hartford-ct", "buffalo-ny"],
  },

  // ─── Vermont ─────────────────────────────────────────────────
  {
    slug: "burlington-vt",
    city: "Burlington",
    state: "VT",
    fullName: "Burlington, Vermont",
    metro: "Burlington Metro / Lake Champlain Region",
    lat: 44.48,
    lng: -73.21,
    keywords: "truck driver jobs Burlington VT, CDL-A jobs Vermont, local truck driver Vermont, OTR driver Vermont, truck driving jobs Montpelier VT",
    description: "Hylas Companion is hiring CDL-A truck drivers in Burlington, Vermont. Local W2 and OTR positions available. Burlington is Vermont's freight hub on I-89 with cross-border access to Montreal.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Price Chopper", "Dollar Tree", "Amazon", "Hannaford"],
    extraCopy: "Burlington is Vermont's largest city and freight hub on I-89, with cross-border access to Montreal via I-89. Vermont's seasonal freight peaks in fall (foliage/apple harvest) and winter (ski equipment). We have local W2 positions covering Northern New England plus OTR lanes South on I-89.",
    nearby: ["boston-ma", "manchester-nh", "buffalo-ny"],
  },

  // ─── Maine ─────────────────────────────────────────────────
  {
    slug: "portland-me",
    city: "Portland",
    state: "ME",
    fullName: "Portland, Maine",
    metro: "Portland Metro / Southern Maine",
    lat: 43.66,
    lng: -70.26,
    keywords: "truck driver jobs Portland ME, CDL-A jobs Maine, local truck driver Maine, OTR driver Maine, truck driving jobs Lewiston ME",
    description: "Hylas Companion is hiring CDL-A truck drivers in Portland, Maine. Local W2 and OTR positions available. Portland is New England's northernmost major freight hub on I-95/I-295.",
    positions: ["Local W2 ($1,200–$2,500/wk)", "OTR Company Driver (85–90¢ CPM)", "Lease Purchase (88%)"],
    accounts: ["Walmart", "Hannaford", "Dollar Tree", "Amazon", "Shaw's"],
    extraCopy: "Portland Maine is the northern terminus of the I-95 East Coast corridor and New England's third-largest port. Strong seasonal freight (lobster, blueberries, lumber) and steady retail distribution freight. We have local W2 positions running the Maine Turnpike plus OTR lanes South to Boston and beyond.",
    nearby: ["boston-ma", "manchester-nh", "burlington-vt"],
  },
];

export function getCityBySlug(slug) {
  return CITY_LOCATIONS.find((c) => c.slug === slug) || null;
}
